import { post } from 'services/client';
import { apiEndpoints } from 'config';

export default {
  copyToWines: async data => {
    const options = { url: apiEndpoints.copyToWines, data };
    return post(options);
  },
};
